import { createApi } from '../client'

const api = createApi('/reporting')

export default api
